import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
const IntroTitle = ({ style, title, secondaryTitle, }) => {
    const theme = useTheme();
    return (_jsxs(Div, { flex: "column", gap: theme.spacing.sm, style: style, children: [_jsx(Typography.Title, { elementTheme: "h3", level: 2, children: title }), _jsx(Typography.Title, { elementTheme: "h6", level: 3, children: secondaryTitle })] }));
};
export default IntroTitle;
